import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const BreadcrumbShareButtonIcon: React.FC<IStyledSVGIconProps> = (
  props
) => {
  return (
    <StyledSVGIcon
      width={props.width || "34"}
      height={props.height || "34"}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle r="17" cx="17" cy="17" fill={props.backgroundColor} />
      <path
        d="M21.0918 26C22.6979 26 24 24.732 24 23.1679C24 21.6037 22.6979 20.3358 21.0918 20.3358C20.2748 20.3358 19.5366 20.6638 19.0083 21.192L13.7147 18.2451C13.781 18.0077 13.8164 17.7579 13.8164 17.5C13.8164 17.2421 13.781 16.9923 13.7147 16.7549L19.009 13.8087C19.5372 14.3365 20.2752 14.6642 21.0918 14.6642C22.6979 14.6642 24 13.3963 24 11.8321C24 10.268 22.6979 9 21.0918 9C19.4856 9 18.1836 10.268 18.1836 11.8321C18.1836 12.09 18.219 12.3398 18.2853 12.5772L12.9917 15.5241C12.4634 14.9959 11.7252 14.6679 10.9082 14.6679C9.30205 14.6679 8 15.9359 8 17.5C8 19.0641 9.30205 20.3321 10.9082 20.3321C11.7248 20.3321 12.4628 20.0044 12.991 19.4766L18.2853 22.4228C18.219 22.6602 18.1836 22.91 18.1836 23.1679C18.1836 24.732 19.4856 26 21.0918 26Z"
        fill={props.color}
      />
    </StyledSVGIcon>
  );
};
